import { Component, OnInit, inject } from '@angular/core';
import { PortalService } from '../portal.service';
import { MediaService, SvgViewboxDirective } from '@exl-ng/mulo-core';
import { UrlUtils } from '../../shared/utils/url.utils';
import { Collection } from '../../shared/interfaces/collection.interface';
import { CollectionsService } from '../../collections/collections.service';
import { I18nService } from '../../core/i18n.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatAnchor, MatButton } from '@angular/material/button';
import { HorizontallerComponent, HorizontallerItemComponent } from '@exl-ng/mulo-common';
import { CenteredBlockLayoutComponent, FeaturedTileComponent } from '@exl-ng/mulo-views';


@Component({
    selector: 'esp-portal-featured-collections',
    templateUrl: './portal-featured-collections.component.html',
    styleUrls: ['./portal-featured-collections.component.scss'],
    imports: [
        CenteredBlockLayoutComponent,
        HorizontallerComponent,
        HorizontallerItemComponent,
        MatAnchor,
        RouterLink,
        FeaturedTileComponent,
        MatButton,
        MatIcon,
        SvgViewboxDirective,
        TranslateModule
    ]
})
export class PortalFeaturedCollectionsComponent implements OnInit {
    private portalService = inject(PortalService);
    private collectionsService = inject(CollectionsService);
    media = inject(MediaService);
    i18nService = inject(I18nService);

    institutionCode = UrlUtils.getParam('institution');
    featuredCollections: Collection[] = [];

    ngOnInit(): void {
        this.collectionsService.getFeaturedCollections().subscribe((data) => {
            this.featuredCollections = data;
        });
    }
}
